import { memo, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Div, SideMenu as SideMenuComponent, useTheme } from "react-better-html";

import { useReduxAction, useReduxState } from "../../utils/hooks";

import Restricted from "../../components/structure/Restricted";
import SideMenu from "../../components/structure/SideMenu";
import AppHeader from "../../components/structure/headers/AppHeader";
import Footer from "../../components/structure/Footer";

function AppRoot() {
   const theme = useTheme();
   const navigate = useNavigate();

   const organizationsList = useReduxState((state) => state.organizations.list);
   const selectedOrganizationId = useReduxState((state) => state.organizations.selectedOrganizationId);

   const getAllWorkspaces = useReduxAction((actions) => actions.workspaces.getAllWorkspaces);

   useEffect(() => {
      if (!organizationsList) return;

      if (!organizationsList.length) navigate("/organization/create");
   }, [organizationsList]);
   useEffect(() => {
      getAllWorkspaces();
   }, [selectedOrganizationId]);

   return (
      <SideMenu>
         <SideMenuComponent.pageHolder additionalTopComponent={<AppHeader />}>
            <Div.column
               width="100%"
               minHeight={`calc(100vh - ${theme.styles.headerHeight + theme.styles.space * 2}px)`}
               gap={theme.styles.space}
            >
               <Div flex={1} paddingBottom={theme.styles.space}>
                  <Restricted needSelectedOrganization>
                     <Outlet />
                  </Restricted>
               </Div>

               <Footer />
            </Div.column>
         </SideMenuComponent.pageHolder>
      </SideMenu>
   );
}

export default memo(AppRoot);
